import { loginReq } from '~/handlers/login.server';
import { RegisterUserReq } from '~/handlers/registerUser.server';
import { ResetPwdReqBody } from '~/handlers/resetPassword.server';
import { SendResetReq } from '~/handlers/sendReset.server';
import { request } from '~/helpers/HttpRequest';

export async function loginApi(data: loginReq) {
  const ret = await request.send<{}>({
    method: 'POST',
    path: '/api/login',
    data,
  });
  return ret;
}

export async function registerApi(data: RegisterUserReq) {
  const ret = await request.send<{}>({
    method: 'POST',
    path: '/api/register',
    data,
  });
  return ret;
}

export async function loginAuthGoogleApi(token: string) {
  const ret = await request.send<{}>({
    method: 'POST',
    path: '/api/loginAuthGoogle',
    data: { token },
  });
  return ret;
}

export async function sendResetPsdEmailApi(data: SendResetReq) {
  const ret = await request.send<{}>({
    method: 'POST',
    path: '/api/sendResetPsdEmail',
    data,
  });
  return ret;
}

export async function resetPasswordApi(data: ResetPwdReqBody) {
  const ret = await request.send<{}>({
    method: 'POST',
    path: '/api/resetPassword',
    data,
  });
  return ret;
}

export async function deleteWorkApi(id: number) {
  const ret = await request.send<{}>({
    method: 'POST',
    path: '/api/deleteWork',
    data: { entryId: id },
  });
  return ret;
}
